"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefIdFromRobustKey = exports.getStyleIdFromRobustKey = exports.createRobustKey = void 0;
var REF_SEPARATOR = '__';
/**
 * Creates a key which consists of styleId and refId (if supplied).
 * The motivation for this is that when two components refer to the same styleId, we have a different result and
 * therefore need a different key.
 * @param styleId - styleId for robust key
 * @param refId - refId for robust key (not required)
 */
function createRobustKey(styleId, refId) {
    if (refId) {
        return "" + styleId + REF_SEPARATOR + refId;
    }
    return styleId;
}
exports.createRobustKey = createRobustKey;
/**
 * extracts the styleId from a robustKey
 * @param robustKey to get styleId from
 */
function getStyleIdFromRobustKey(robustKey) {
    return robustKey.split(REF_SEPARATOR)[0];
}
exports.getStyleIdFromRobustKey = getStyleIdFromRobustKey;
/**
 * extracts the refId from a robustKey
 * @param robustKey to get refId from
 */
function getRefIdFromRobustKey(robustKey) {
    return robustKey.split(REF_SEPARATOR)[1];
}
exports.getRefIdFromRobustKey = getRefIdFromRobustKey;
//# sourceMappingURL=internal.js.map